import React from 'react';
import Intro from './components/Intro';
import AboutUs from './components/AboutUs';
import PrAdvantages from './components/ProgramAdvantages';
import Services from './components/Services';
import Stages from './components/Stages';
import Clients from './components/Clients';
import Products from './components/Products';
import MailCompanent from './components/MailCompanent';
import { useTranslation } from "react-i18next";


const MainPage = () => {
  
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng); // Меняем язык
  };
  return (
    <div>
      <Intro/>
      <AboutUs/>
      <Clients/>
      <Services/>
      <PrAdvantages/>
      <Products/>
      <Stages/>
      <MailCompanent/>
    </div>
  )
}

export default MainPage
